import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';
import { CategoryModel } from './communications.model';

@Injectable()
export class CommunicationsActions {
    static selectedCategory = createAction(
        "[Communication:Category] Select Category", props<{ selectedCategory: CategoryModel }>()
    );
}